import { useAuthenticator } from "@aws-amplify/ui-react";
import liff from "@line/liff/dist/lib";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect } from "react";
import {
  Navigate,
  Outlet,
  RouteProps,
  useSearchParams,
} from "react-router-dom";
import { SignInProgress } from "../components/Progress";
import {
  useApplicationStore,
  ResourceOperation,
} from "../context/ApplicationStoreContext";
import { CustomerRepository } from "../DAL/repositories/CustomerRepository";
import { AppAuth } from "../util/AppAuth";

export const ProtectedRoute: React.FC<RouteProps> = () => {
  const { route, authStatus, user } = useAuthenticator((context) => [
    context.route,
    context.authStatus,
    context.user
  ]);
  const { state, dispatch } = useApplicationStore();
  useEffect(() => {
    console.log(
      `route:${route}, authStatus:${authStatus},user:${user?.getUsername()}, customer:${
        state.customer
      }`
    );
    if (route === "setup" && authStatus !== "authenticated"){
      AppAuth.initializeLiff().then(()=>AppAuth.federatedSignIn("LINE"))
    }
    if (
      authStatus === "authenticated" &&
      route === "authenticated" &&
      state.customer === null
    ) {
      liff.init({ liffId: process.env.REACT_APP_LIFF_ID! }).then(async () => {
        console.log(user);
        const customerClient = CustomerRepository();
        customerClient.get(user.username!).then((customer) => {
          console.log(customer);
        });
      });
    }
  }, [authStatus, route]);

  return authStatus === "authenticated" ? (
    <Outlet />
  ) : authStatus === "configuring" ? (
    <SignInProgress />
  ) : (
    <Navigate to="/login" />
  );
};
